/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Realitymix_SetupInputs */

const cs_realitymix_setup = /** @type {(inputs: Realitymix_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nastavit RealityMIX RK`)
};

const en_realitymix_setup = /** @type {(inputs: Realitymix_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set up RealityMIX RK`)
};

/**
* | output |
* | --- |
* | "Set up RealityMIX RK" |
*
* @param {Realitymix_SetupInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const realitymix_setup = /** @type {((inputs?: Realitymix_SetupInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Realitymix_SetupInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_realitymix_setup(inputs)
	return cs_realitymix_setup(inputs)
});